module.exports = __webpack_public_path__ + "images/Bubbles_AppleandElderflower_2.png";